import { useState, useEffect } from 'react'

interface CurrencyInfo {
  code: string
  symbol: string
  rate: number
  countryName: string
  loading: boolean
}

const CURRENCY_MAP: Record<
  string,
  { code: string; symbol: string; rate: number }
> = {
  CR: { code: 'CRC', symbol: '₡', rate: 510 },
  MX: { code: 'MXN', symbol: 'MX$', rate: 17.2 },
  CO: { code: 'COP', symbol: 'COL$', rate: 4050 },
  AR: { code: 'ARS', symbol: 'ARS$', rate: 910 },
  BR: { code: 'BRL', symbol: 'R$', rate: 5.05 },
  PE: { code: 'PEN', symbol: 'S/', rate: 3.72 },
  CL: { code: 'CLP', symbol: 'CLP$', rate: 955 },
  GT: { code: 'GTQ', symbol: 'Q', rate: 7.8 },
  HN: { code: 'HNL', symbol: 'L', rate: 24.7 },
  NI: { code: 'NIO', symbol: 'C$', rate: 36.6 },
  PA: { code: 'PAB', symbol: 'B/.', rate: 1 },
  EC: { code: 'USD', symbol: '$', rate: 1 },
  SV: { code: 'USD', symbol: '$', rate: 1 },
  UY: { code: 'UYU', symbol: 'UY$', rate: 39.5 },
  PY: { code: 'PYG', symbol: '₲', rate: 7350 },
  BO: { code: 'BOB', symbol: 'Bs', rate: 6.91 },
  DO: { code: 'DOP', symbol: 'RD$', rate: 58.5 },
  VE: { code: 'VES', symbol: 'Bs.D', rate: 36.5 },
  ES: { code: 'EUR', symbol: '€', rate: 0.92 },
  FR: { code: 'EUR', symbol: '€', rate: 0.92 },
  DE: { code: 'EUR', symbol: '€', rate: 0.92 },
  IT: { code: 'EUR', symbol: '€', rate: 0.92 },
  PT: { code: 'EUR', symbol: '€', rate: 0.92 },
  GB: { code: 'GBP', symbol: '£', rate: 0.79 },
  CA: { code: 'CAD', symbol: 'CA$', rate: 1.36 },
  US: { code: 'USD', symbol: '$', rate: 1 },
}

const DEFAULT_CURRENCY = { code: 'USD', symbol: '$', rate: 1 }

export function useCurrency(): CurrencyInfo {
  const [info, setInfo] = useState<CurrencyInfo>({
    code: 'USD',
    symbol: '$',
    rate: 1,
    countryName: '',
    loading: true,
  })

  useEffect(() => {
    const controller = new AbortController()

    fetch('https://ipapi.co/json/', { signal: controller.signal })
      .then((res) => res.json())
      .then((data) => {
        const countryCode = data.country_code || ''
        const match = CURRENCY_MAP[countryCode] || DEFAULT_CURRENCY
        setInfo({
          code: match.code,
          symbol: match.symbol,
          rate: match.rate,
          countryName: data.country_name || '',
          loading: false,
        })
      })
      .catch(() => {
        setInfo((prev) => ({ ...prev, loading: false }))
      })

    return () => controller.abort()
  }, [])

  return info
}

export function formatPrice(
  usdPrice: number,
  rate: number,
  symbol: string,
): string {
  const converted = Math.round(usdPrice * rate)
  return `${symbol}${converted.toLocaleString()}`
}
